/*
 * @Author: chengyu
 * @Date: 2022-10-09 16:21:32
 * @Description: 描述
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getDefaultOptions } from '../config';
import { ServiceTypeEnum } from '../enums';
import { createContext } from '../request/fetchContext';
import { isArray, isObject } from './is';
import omit from './lodash/omit';
import pick from './lodash/pick';
import { mapError } from './logger';
import { removeEmpty, removeEmptyString } from './transform';
/**
 * 切断引用关系，防止数据被引用修改
 */
export function cutOffProperty(value) {
    return JSON.parse(JSON.stringify(value));
}
/**
 * 异常就返回空串
 */
export function JsonStringify(data) {
    try {
        return JSON.stringify(data);
    }
    catch (e) {
        mapError('JsonStringify', e);
    }
    return '';
}
/**
 * 合并默认参数，参数来源于全局配置&单接口入参
 */
export function mergeDefaultOptions(single) {
    var options = getDefaultOptions();
    if (isObject(single)) {
        var _single = removeEmptyString(removeEmpty(single));
        options = __assign(__assign({}, options), _single);
    }
    return options;
}
/**
 * 获取缓存配置参数
 */
export function getCacheOptions(cache) {
    if (isObject(cache)) {
        return {
            httpCache: cache.httpCache,
            resultCache: cache.resultCache,
        };
    }
    return undefined;
}
/**
 * 获取逆地理缓存配置
 * @param cache
 */
export function getGeoCacheOptions(cache) {
    if (isObject(cache)) {
        var keys_1 = ['geoHashCache', 'httpCache'];
        var _cache = removeEmpty(pick(cache, keys_1));
        if (isObject(_cache) && Object.keys(_cache).some(function (v) { return keys_1.includes(v); })) {
            return _cache;
        }
    }
    return undefined;
}
/**
 * 合并配置选项
 */
export function mergeOptions(method, options) {
    var context = createContext();
    var defaultOptions = mergeDefaultOptions(options);
    return __assign(__assign({ 
        /**
         * 默认调用顺序，哈罗服务优先，兜底高德
         */
        serveSort: [ServiceTypeEnum.HELLO, ServiceTypeEnum.GAODE] }, defaultOptions), { context: context, method: method });
}
export function mergeParams(paramsDefault, params) {
    // 默认参数
    var _paramsDefault = {};
    var _params;
    // eslint-disable-next-line
    if (arguments.length === 1) {
        _params = paramsDefault;
        // eslint-disable-next-line
    }
    else if (arguments.length === 2) {
        _params = params;
        _paramsDefault = isObject(paramsDefault) ? paramsDefault : {};
    }
    if (isObject(_params)) {
        var convertParams = removeEmpty(_params);
        return __assign(__assign({}, _paramsDefault), convertParams);
    }
    return _paramsDefault;
}
function checkServeSort(serveSort) {
    var isType = serveSort.every(function (v) {
        // @ts-ignore
        return [ServiceTypeEnum.HELLO, ServiceTypeEnum.GAODE].includes(v);
    });
    if (isType) {
        if (serveSort.length === 2) {
            return serveSort[0] !== serveSort[1];
        }
    }
    return isType;
}
/**
 * 确定服务调用顺序
 */
export function services(lbs, amap, options) {
    var _a;
    if (isObject(options)) {
        var serveSort = options.serveSort;
        if (isArray(serveSort) && serveSort.length > 0) {
            var _serveSort = serveSort.slice(0, 2);
            if (checkServeSort(_serveSort)) {
                var firstServers = _serveSort[0], lastServers = _serveSort[1];
                var servicesMap = (_a = {},
                    _a[ServiceTypeEnum.HELLO] = lbs,
                    _a[ServiceTypeEnum.GAODE] = amap,
                    _a);
                if (lastServers) {
                    return [servicesMap[firstServers], servicesMap[lastServers]];
                }
                return [servicesMap[firstServers]];
            }
        }
    }
    return [lbs, amap];
}
/**
 * 将缓存参数排除
 */
export function noCacheOptions(options) {
    var omitKeys = ['cache'];
    return omit(options, omitKeys);
}
//# sourceMappingURL=data:application/json;base64,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